const LogoIcon = (): JSX.Element => {
  return (
    <svg width="39" height="30" viewBox="0 0 131 145" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99851 115.608C3.81133 112.036 0 105.434 0 98.2888V41.3297L10.8802 47.3953C17.2151 50.9269 21.1416 57.6113 21.1416 64.8641V97.6262L65.0992 123.01L109.057 97.6262V64.8645C109.057 57.6117 112.983 50.9273 119.318 47.3957L130.198 41.3301V98.2888C130.198 105.434 126.387 112.036 120.2 115.608L75.1007 141.652C68.9119 145.225 61.2865 145.225 55.0977 141.652L9.99851 115.608Z"
        fill="#0A3D6C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.1001 2.83269C68.9113 -0.741108 61.2859 -0.741105 55.0971 2.8327L3.59375 32.5741L15.1951 39.0417C21.3429 42.469 28.8399 42.4124 34.9352 38.8925L54.5278 27.5785V104.436L65.0986 110.329L75.6694 104.436V27.5785L95.2624 38.8928C101.358 42.4126 108.855 42.4692 115.003 39.0419L126.604 32.5743L75.1001 2.83269Z"
        fill="#2482D8"
      />
    </svg>
  )
}

export default LogoIcon
